export default "__VITE_ASSET__C1bMih0E__"